import React from 'react';
import { connect } from "react-redux";
import GoogleMaps from './components/GoogleMaps';
import './map.scss';

const App = () => (
  <GoogleMaps />
);

const mapStateToProps = (state) => {
  return {
    // options: state.options,
    // steps: state.steps,
    // stepone: state.stepone
  }
};
const mapDispatchToProps = {};

export const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);